import crawlers from 'crawler-user-agents'

const crawlersRegex = new RegExp(
  crawlers.map(({ pattern }) => pattern).join('|'),
  'i'
)

/**
 * takes a UA string. returns true if the user agent is a crawler.
 * @param {string} userAgent - e.g. window.location.userAgent
 * @return {boolean}
 */
export default (userAgent) => crawlersRegex.test(userAgent)

